import { model as i18n } from '!/i18n'
import {
  callableTranslate,
  type PlayerTranslationKeys,
} from '@/hooks/useTranslate'
import { combine, type Store } from 'effector'

const PLAYER_I18N_KEYS = [
  'live',
  'error_code',
  'playback_error',
  'network_error_title',
  'drm_error_title',
  'geoblock_error_title',
  'refresh_or_select_error',
  'drm_error_text',
  'playing_media_error',
  'network_error_message',
  'stream_or_network_issues_error',
  'server_error',
  'loading_content_error_text',
  'cannot_play_video_error',
  'payment_required_error',
  'browser_recognize_error_message',
  'something_went_wrong_error',
  'protected_content_error',
  'select_different_item_error',
  'try_browser_or_update_error',
  'settings',
  'subtitles',
  'subtitles_closed_captions',
  'closed_captions',
  'button_audio',
  'description',
  'directors',
  'stars',
  'off',
  'quality',
  'quality_auto',
  'default',
  'casting_status',
  'casting_activated',
  'please_tap_button',
  'stop_casting_message',
  'skip_ad_button',
  'ad_current_of_amount',
  'on',
  'reset_setting',
  'text_size',
  'text_color',
  'background_transparancy',
  'white_color',
  'blue_color',
  'green_color',
  'purple_color',
  'yellow_color',
  'red_color',
  'light_transparancy',
  'medium_transparancy',
  'full_transparancy',
  'custom_setting',
  'small_text_size',
  'medium_text_size',
  'large_text_size',
  'background',
  'language',
  'pop_on',
  'roll_up',
  'paint_on',
  'monospaced_serif',
  'proportional_serif',
  'monospaced_sans_serif',
  'proportional_sans_serif',
  'casual',
  'cursive',
  'small_capitals',
  'black_color',
  'magenta_color',
  'cyan_color',
  'none',
  'raised',
  'depressed',
  'outline',
  'uniform',
  'drop_shadow',
  'character_edge_style',
  'window_opacity',
  'window_color',
  'background_opacity',
  'background_color',
  'font_opacity',
  'font_size',
  'font_color',
  'font_family',
  'display',
  'subtitles_unavailable',
  'subtitles_preview',
]

const PLAYER_I18N_KEYS_TITLE = [
  'content_geoblock',
  'sorry_item_not_available',
  'geoblock_title',
]

// TODO this should be removed later - when player got its own i18n instance
export const $genericPlayerTranslations: Store<PlayerTranslationKeys> = combine(
  i18n.$t,
  ({ t }) => {
    const translates: PlayerTranslationKeys = {}
    PLAYER_I18N_KEYS.forEach((key) => {
      translates[key] = callableTranslate(t, key)
    })

    return translates
  }
)

export const $titlePlayerTranslations: Store<
  (title: string | undefined) => PlayerTranslationKeys
> = combine(i18n.$t, ({ t }) => (title) => {
  const translates: PlayerTranslationKeys = {}
  if (!title) return translates

  PLAYER_I18N_KEYS_TITLE.forEach((key) => {
    translates[key] = callableTranslate(t, key)
  })

  return translates
})
